import { DEFAULT_LANGUAGE } from './language.constants';
import { isDevMode } from '@angular/core';
import {
  MissingTranslationHandler,
  MissingTranslationHandlerParams,
  RootTranslateServiceConfig,
} from '@ngx-translate/core';
import { TranslateHttpLoaderConfig } from '@ngx-translate/http-loader';

const translationConfig = {
  fallbackLang: DEFAULT_LANGUAGE,
};

class CustomMissingTranslationHandler implements MissingTranslationHandler {
  handle(params: MissingTranslationHandlerParams): string {
    const missingKey = params.key;

    if (isDevMode()) {
      console.warn(`[i18n] Missing translation for key: "${missingKey}"`);
    }

    return missingKey;
  }
}

export const translateHttpLoaderConfig: Partial<TranslateHttpLoaderConfig> = {
  prefix: 'assets/i18n/',
  suffix: '.json',
};

export const rootTranslateServiceConfig: RootTranslateServiceConfig = {
  ...translationConfig,
  missingTranslationHandler: {
    provide: MissingTranslationHandler,
    useClass: CustomMissingTranslationHandler,
  },
};
